import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Man = () => {
    // Initialize AOS
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: false,
            offset: 100,
            easing: 'ease-out-cubic',
        });
    }, []);

    return (
        <>
            {/* Page Header Start */}
            <div className="container-fluid page-header py-5" style={{marginBottom: "6rem"}} data-aos="fade-down">
                <div className="container py-5">
                    <h1 className="display-3 text-white mb-3">Man Power Services</h1>
                </div>
            </div>
            {/* Page Header End */}

            {/* Introduction Section */}
            <div className="container-xxl py-5">
                <div className="container">
                    <div className="row g-5 align-items-center">
                        <div className="col-lg-6" data-aos="fade-right" data-aos-delay="100">
                            <h6 className="text-primary text-uppercase mb-2">Workforce Solutions</h6>
                            <h1 className="display-6 mb-4">Reliable Manpower Services for Businesses</h1>
                            <p className="mb-4">A2Z Solutions provides comprehensive manpower services to help businesses meet their staffing needs efficiently and effectively. Our ISO 9001:2015 certified processes ensure quality workforce solutions tailored to your specific requirements.</p>
                            
                            <p className="mb-4">We understand that finding the right talent at the right time can be challenging for businesses. Our manpower services bridge this gap by providing qualified, trained, and reliable professionals for various roles and industries across Mysuru and surrounding regions.</p>
                            
                            <div className="row g-3">
                                <div className="col-sm-6" data-aos="fade-up" data-aos-delay="200">
                                    <div className="d-flex">
                                        <i className="fa fa-user-check text-primary fa-2x flex-shrink-0 me-3"></i>
                                        <div>
                                            <h5 className="mb-1">Screened Professionals</h5>
                                            <p className="mb-0">Verified and trained staff</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6" data-aos="fade-up" data-aos-delay="300">
                                    <div className="d-flex">
                                        <i className="fa fa-calendar-check text-primary fa-2x flex-shrink-0 me-3"></i>
                                        <div>
                                            <h5 className="mb-1">Flexible Staffing</h5>
                                            <p className="mb-0">Short-term & long-term options</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className="col-lg-6" data-aos="fade-left" data-aos-delay="100">
                            <div className="position-relative">
                                <img src="img/man-1.jpg" className="img-fluid rounded shadow" style={{width: "100%", maxWidth: "800px", padding: "10px"}} alt="Manpower Team"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            {/* Government Certificates Section */}
            <div className="container-xxl py-5">
                <div className="container">
                    <div className="text-center" data-aos="fade-up" data-aos-delay="100">
                        <h6 className="text-primary text-uppercase mb-2">Government Recognitions</h6>
                        <h1 className="display-6 mb-5">Officially Registered & Certified</h1>
                        <p className="mb-5">Our formal registrations with government authorities demonstrate our commitment to operating with full compliance and transparency.</p>
                    </div>

                    <div className="row g-5 align-items-center">
                        {/* MSME Certificate on the left */}
                        <div className="col-lg-6" data-aos="fade-right" data-aos-delay="200">
                            <div className="position-relative h-100">
                                <div className="certificate-frame p-3 bg-white rounded-lg shadow-lg">
                                    <img
                                        className="img-fluid rounded w-100"
                                        src="img/man-certificate-1.png"
                                        style={{ 
                                            maxHeight: "460px", 
                                            objectFit: "contain",
                                            border: "1px solid #dee2e6"
                                        }}
                                        alt="MSME Udyam Registration Certificate"
                                        data-aos="zoom-in"
                                        data-aos-delay="300"
                                    />
                                </div>
                                
                                <div className="mt-4" data-aos="fade-up" data-aos-delay="400">
                                    <h4 className="mb-3">MSME Udyam Registration</h4>
                                    <p className="mb-0">
                                        Our official recognition as a Micro, Small & Medium Enterprise under the Government of India's 
                                        Udyam registration scheme validates our status as a genuine business entity. This registration 
                                        enables us to participate in government initiatives and demonstrates our commitment to 
                                        contributing to the nation's economic growth through our IT and business support services.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Labour Department Certificate on the right */}
                        <div className="col-lg-6" data-aos="fade-left" data-aos-delay="200">
                            <div className="position-relative h-100">
                                <div className="certificate-frame p-3 bg-white rounded-lg shadow-lg">
                                    <img
                                        className="img-fluid rounded w-100"
                                        src="img/man-certificate-2.png"
                                        style={{ 
                                            maxHeight: "480px", 
                                            objectFit: "contain",
                                            border: "1px solid #dee2e6"
                                        }}
                                        alt="Karnataka Labour Department Registration Certificate"
                                        data-aos="zoom-in"
                                        data-aos-delay="300"
                                    />
                                </div>
                                
                                <div className="mt-4" data-aos="fade-up" data-aos-delay="400">
                                    <h4 className="mb-3">Labour Department Registration</h4>
                                    <p className="mb-0">
                                        Registered under the Karnataka Shops and Commercial Establishments Act, this certification 
                                        confirms our compliance with state labor regulations. It demonstrates our commitment to 
                                        maintaining proper workplace standards and following all statutory requirements for employee 
                                        welfare and establishment operations in Karnataka.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-5">
                        <div className="col-12" data-aos="fade-up" data-aos-delay="500">
                            <div className="bg-light p-4 rounded text-center">
                                <p className="mb-0">
                                    <i className="fas fa-check-circle text-primary me-2"></i>
                                    These certifications ensure that A2Z Solutions operates with full legal compliance, providing 
                                    our clients and partners with the assurance that we follow all government regulations and 
                                    maintain proper business practices.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            {/* Manpower Services Content Section */}
            <div className="container-xxl py-5">
                <div className="container">
                    <div className="row g-5">
                        <div className="col-lg-12">
                            <h2 className="mb-4" data-aos="fade-up" data-aos-delay="100">Our Manpower Services</h2>
                            
                            <p className="mb-4" data-aos="fade-up" data-aos-delay="150">A2Z Solutions offers a wide range of manpower services designed to address different workforce needs of businesses. From temporary staffing to specialized professionals, we provide comprehensive workforce solutions.</p>
                            
                            <h4 className="mb-3" data-aos="fade-up" data-aos-delay="200">Temporary and Contract Staffing</h4>
                            <p className="mb-4" data-aos="fade-up" data-aos-delay="250">We provide temporary and contract staff for short-term projects, seasonal demands, maternity leaves, and special assignments. Our flexible staffing solutions help businesses manage workload fluctuations without the commitment of permanent hiring.</p>
                            
                            <h4 className="mb-3" data-aos="fade-up" data-aos-delay="300">Specialized Technical Staffing</h4>
                            <p className="mb-4" data-aos="fade-up" data-aos-delay="350">For technical and specialized roles, we provide qualified professionals with specific skill sets including IT support, data entry operators, administrative staff, customer service representatives, and other specialized positions based on client requirements.</p>
                            
                            <h4 className="mb-3" data-aos="fade-up" data-aos-delay="400">Event and Project Staffing</h4>
                            <p className="mb-4" data-aos="fade-up" data-aos-delay="450">We supply manpower for events, exhibitions, conferences, and special projects. Our event staffing services include registration staff, ushers, crowd managers, and support personnel to ensure smooth event operations.</p>
                            
                            <h4 className="mb-3" data-aos="fade-up" data-aos-delay="500">Office Support Staff</h4>
                            <p className="mb-4" data-aos="fade-up" data-aos-delay="550">Comprehensive office support staffing including receptionists, office assistants, clerical staff, and administrative support personnel. We ensure that our office support staff are trained in basic office software and communication skills.</p>
                            
                            <h4 className="mb-3" data-aos="fade-up" data-aos-delay="600">Industrial and Warehouse Staffing</h4>
                            <p className="mb-4" data-aos="fade-up" data-aos-delay="650">Manpower solutions for industrial operations, warehouses, and logistics centers. We provide trained personnel for material handling, inventory management, packing, and other operational roles in industrial settings.</p>
                            
                            <div className="text-center my-5" data-aos="zoom-in" data-aos-delay="700">
                                <img src="img/man-2.png" className="img-fluid rounded shadow-lg" alt="Workforce Management" style={{maxHeight: "400px"}}/>
                            </div>

                            <h2 className="mb-4 mt-5" data-aos="fade-up" data-aos-delay="750">Our Staffing Process</h2>
                            
                            <h4 className="mb-3" data-aos="fade-up" data-aos-delay="800">Thorough Screening and Selection</h4>
                            <p className="mb-4" data-aos="fade-up" data-aos-delay="850">We implement a rigorous screening process that includes background verification, skill assessment, and reference checks. Our selection criteria ensure that we provide only qualified and reliable professionals to our clients.</p>
                            
                            <h4 className="mb-3" data-aos="fade-up" data-aos-delay="900">Skill Verification and Training</h4>
                            <p className="mb-4" data-aos="fade-up" data-aos-delay="950">Before deployment, we verify candidate skills through practical assessments. For specialized roles, we provide additional training to ensure that our staff meet the specific requirements of each client and role.</p>
                            
                            <h4 className="mb-3" data-aos="fade-up" data-aos-delay="1000">Performance Monitoring and Support</h4>
                            <p className="mb-4" data-aos="fade-up" data-aos-delay="1050">We maintain regular contact with both clients and our deployed staff to monitor performance, address any concerns, and ensure satisfactory service delivery. Our support team is available to handle any staffing-related issues promptly.</p>
                            
                            <h4 className="mb-3" data-aos="fade-up" data-aos-delay="1100">Flexible Engagement Models</h4>
                            <p className="mb-4" data-aos="fade-up" data-aos-delay="1150">We offer flexible engagement models including daily, weekly, monthly, and project-based staffing. Our contracts are designed to provide businesses with the flexibility they need while ensuring compliance with labor regulations.</p>
                            
                            <div className="bg-light p-4 rounded mt-5" data-aos="fade-up" data-aos-delay="1200">
                                <h4 className="mb-3">Why Choose A2Z Solutions for Manpower Services?</h4>
                                <p className="mb-3">As an ISO 9001:2015 certified organization, we maintain high standards in our staffing processes. Our quality management system ensures consistency in candidate screening, training, and service delivery.</p>
                                
                                <p className="mb-3">With years of experience serving businesses in Mysuru and surrounding areas, we understand local workforce dynamics and business requirements. Our deep understanding of regional employment trends helps us provide staffing solutions that work.</p>
                                
                                <p className="mb-3">We maintain a database of pre-screened, qualified professionals across various skill categories. This enables us to respond quickly to staffing requests and provide suitable candidates within short notice periods.</p>
                                
                                <p className="mb-0">Whether you need temporary staff for a short project or specialized professionals for longer engagements, A2Z Solutions provides reliable manpower services that help businesses optimize their workforce management. Contact us to discuss your staffing needs and discover how we can support your business operations with qualified manpower solutions.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <style jsx>{`
                .page-header {
                    background: linear-gradient(rgba(6, 3, 21, 0.8), rgba(6, 3, 21, 0.8)), 
                                url('img/carousel-01.jpg') no-repeat center center;
                    background-size: cover;                }
                
                .certificate-frame {
                    transition: all 0.3s ease;
                }
                
                .certificate-frame:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 10px 25px rgba(0,0,0,0.15);
                }
            `}</style>
        </>
    );       
}

export default Man;